import "./Login.css";
import axios from "axios";
import Cookies from 'js-cookie';
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import React, { useState, useEffect } from "react";
import EyeIcon from "../../images/icons/eye-icon.svg";
import { useSelector, useDispatch } from "react-redux";
import LoginImage from "../../images/login/lg-img.png";
import { loginTemp } from "../../features/auth/authSlice";
import Spinner from "../../components/Animations/Spinner";
import EyeCrossed from "../../images/icons/eye-crossed.svg";
import LoginImageMobile from "../../images/login/lg-img-mob.png";
import { login } from '../../features/auth/authSlice';
import { setDashboardCurrencyRx } from "../../features/invoice/invoiceSlice";
import { setAppSettings } from "../../features/appSettings/appSettingsSlice.js";
import { setForex } from "../../features/forex/forexSlice.js";
import { getBrandLogo, getBrandLogoAlt } from "../../utils/brandLogo";


function Login() {
  const encodePassword = (value = "") => {
    try {
      const encoder = new TextEncoder();
      const bytes = encoder.encode(value);
      let binary = "";
      bytes.forEach((b) => {
        binary += String.fromCharCode(b);
      });
      return btoa(binary);
    } catch (error) {
      console.error("Failed to encode password:", error);
      return "";
    }
  };

  const decodePassword = (value = "") => {
    try {
      const binary = atob(value);
      const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
      const decoder = new TextDecoder();
      return decoder.decode(bytes);
    } catch (error) {
      console.error("Failed to decode password:", error);
      return "";
    }
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "", });
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // State for controlling password visibility
  const { email, password } = formData;
  const [errorMessage, setErrorMessage] = useState(null);
  const { user, isLoading, isError, isSuccess, message } = useSelector(
    (state) => state.auth
  );

  const onChange = (e) => {
    setErrorMessage(null)
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const fetchForex = async () => {
    try {
      const response = await axios.post(`/api/forex/get`, { base_currency: "USD" });

      const forexData = response.data?.json;
      if (forexData) {
        await dispatch(setForex(forexData));
        return forexData;
      } else {
        console.error("Forex data is missing in response.");
        return null;
      }

    } catch (error) {
      console.error("Failed to fetch forex data:", error);

      // Optional: Show user-friendly toast (requires react-toastify or similar)
      toast?.error("Unable to fetch forex rates. Please try again later.", {
        position: "bottom-right",
        autoClose: 2000,
      });

      return null; // or throw error if you want the caller to handle it
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!email || !password) {
      setErrorMessage({ message: "", field: "both" });
      setLoading(false);
      return;
    }

    if (rememberMe) {
      Cookies.set('email', email, { expires: 30 });
      Cookies.set('password', encodePassword(password), { expires: 30 });
    } else {
      Cookies.remove('email');
      Cookies.remove('password');
    }

    try {
      const res = await fetch("/api/user/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!data.token) {
        setErrorMessage(data);
        toast.error(data.message || "Login failed.", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
        });
        return;
      }

      await dispatch(loginTemp(data));
      fetchForex();

      let favIcon_fileName = "fav_icon_default.jpeg";
      let app_owner_name = "TalenTon";
      let app_owner_id = "";

      const authHeader = { headers: { Authorization: `Bearer ${data.token}` } };

      let settingsData;
      let favIconData;
      var authSettingsBundle = null;
      try {
        authSettingsBundle = await axios.get(`/api/auth/config/bundle/${data.appId}/${data._id}`, authHeader);
        console.log(authSettingsBundle.data,'authSettingsBundle');
        settingsData = authSettingsBundle.data.appSettings;
        favIconData = authSettingsBundle.data.ownerDetails;
        const userSettingsData = authSettingsBundle.data.userSettings;

        if (settingsData !== null) {
          settingsData.timeFormat = userSettingsData?.timeFormat || 12;
          settingsData.currency = userSettingsData?.currency || "USD";
          settingsData.timeZone = userSettingsData?.timeZone || null;
        }

        if (favIconData) {
          favIcon_fileName = favIconData.fav_icon || favIcon_fileName;
          app_owner_name = favIconData.commercial_name || app_owner_name;
          app_owner_id = favIconData._id || app_owner_id;
        }

        await dispatch(setAppSettings({
          ...settingsData,
          favIcon: favIcon_fileName,
          app_ownername: app_owner_name,
          app_ownerid: app_owner_id
        }));
      } catch (subErr) {
        console.error("App settings fetch failed:", subErr);
        global?.config?.slackMessage?.("App settings fetch error: " + subErr.toString());
      }

      try {
        const currencyRes = authSettingsBundle.data.invoiceCurrencies;
        if (currencyRes.length > 0) {
          localStorage.setItem('DashboardCurrency', JSON.stringify(currencyRes[0]));
          dispatch(setDashboardCurrencyRx(currencyRes[0]));
        }
      } catch (currencyErr) {
        console.error("Dashboard currency fetch failed:", currencyErr);
      }

      // 2FA logic
      let twoFactorEnabled = false;
      let twoFactorEnabledAt = null;

     
      if (settingsData?.twoFa === true||data.is_2fa_enabled === true) {
        twoFactorEnabled = true;
        twoFactorEnabledAt = parseInt(localStorage.getItem('twoFactorEnabledAt'), 10);
      } else {
        twoFactorEnabled = JSON.parse(localStorage.getItem('twoFactorEnabled')) || false;
        twoFactorEnabledAt = parseInt(localStorage.getItem('twoFactorEnabledAt'), 10);
      }

    
      if (twoFactorEnabled && twoFactorEnabledAt && Date.now() - twoFactorEnabledAt < 30 * 24 * 60 * 60 * 1000) {
        dispatch(login(data));
        // Set flag for new login session to show sidebar video
        sessionStorage.setItem('isNewLogin', 'true');
        navigate('/user/dashboard');
      } else if (twoFactorEnabled) {
        navigate("/2fa");
      } else {
        dispatch(login(data));
        // Set flag for new login session to show sidebar video
        sessionStorage.setItem('isNewLogin', 'true');
        navigate('/user/dashboard');
      }

    } catch (err) {
      console.error("Login process failed:", err);
      global?.config?.slackMessage?.("Login Error: " + err.toString());

      toast.error(err.message || "An unexpected error occurred.", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });

    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const element = document.getElementById('userback_button_container');
    const previousDisplay = element?.style?.display;

    const cleanup = () => {
      if (element) {
        element.style.display = previousDisplay ?? '';
      }
    };

    try {
      if (element) {
        element.style.display = 'none';
      }

      // Load stored email (if any)
      const storedEmail = Cookies.get('email');
      const storedPassword = Cookies.get('password');

      if (storedEmail || storedPassword) {
        setFormData((prev) => ({
          ...prev,
          email: storedEmail || prev.email,
          password: storedPassword ? decodePassword(storedPassword) : prev.password,
        }));
        setRememberMe(true);
      }

      // Auto-redirect if already logged in
      const token = localStorage.getItem("user");
      if (token) {
        navigate("/user/dashboard");
        return cleanup;
      }

      // Handle login error
      if (isError && message) {
        toast.error(message, {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
        });
      }

      // Redirect after successful login
      if (isSuccess && user) {
        navigate("/user/dashboard");
      }
    } catch (error) {
      console.error("useEffect error:", error);
      toast.error("Something went wrong during initialization.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
    }

    return cleanup;
  }, [user, isError, isSuccess, message, navigate]);

  if (isLoading) {
    return <Spinner />;
  }

  const handleRememberMeChange = (event) => {
    setRememberMe(Boolean(event?.target?.checked));
  };

  return (
    <div>
      <div className="login-outer-forget auth-divide">
        <div className="login-inner">
          <div className="top-logo-mobile">
            <Link to="/"><img src={getBrandLogo()} alt={getBrandLogoAlt()} /></Link>
          </div>
          <div className="lg-lft">
            <img src={LoginImage} alt="desktop" className="desktop-lg-img" fetchpriority="high" />
            <img src={LoginImageMobile} alt="mobile" className="mobile-lg-img" />
          </div>
          <div className="lg-rgt">
            <div className="top-logo">
              <Link to="/"><img src={getBrandLogo()} alt={getBrandLogoAlt()} /></Link>
            </div>
            <div className="login-form-sec">
              <form onSubmit={onSubmit}>
                <h3>Hi! Please enter your details.</h3>
                <div className="form-outer email">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    placeholder="email@gmail.com"
                    value={email}
                    onChange={onChange}
                    className={errorMessage && (errorMessage.field === 'username' || errorMessage.field === "both") && "error"}
                  />
                </div>
                <div className="form-outer password">
                  <label>Password</label>
                  <div className="password-input-wrapper">
                    <input
                      type={showPassword ? "text" : "password"} // Use the showPassword state to toggle between text and password type
                      id="password"
                      name="password"
                      placeholder="Password"
                      value={password}
                      onChange={onChange}
                      className={errorMessage && (errorMessage.field === 'password' || errorMessage.field === "both") && "error"}
                    />
                    <img
                      src={showPassword ? EyeCrossed : EyeIcon} // Use the custom eye icon image based on the showPassword state
                      className="password-toggle-icon"
                      alt="Toggle Password"
                      onClick={() => setShowPassword(!showPassword)} // Toggle showPassword state on eye icon click
                    />
                  </div>
                </div>
                <div className="remb-for">
                  <div className="remember-me">
                    <input type="checkbox" checked={rememberMe} onChange={handleRememberMeChange} />Remember me
                  </div>
                  <div className="forget-password">
                    <Link to="./forget-password">I forgot my password</Link>
                  </div>
                </div>
                <button className="login-button" disabled={loading}>
                  {loading ?
                    <div className="outter-load-table">
                      <ThreeDots
                        height="38"
                        width="40"
                        radius="9"
                        color="white"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        visible={true}
                      />
                    </div> : "Log In"
                  }
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

Login.propTypes = {};
export default Login;